module.exports = __webpack_public_path__ + "static/diverse-group-of-women-desktop.eacf6a7c.webp";